/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { authTeamsRemoveMember } from "../../funcs/authTeamsRemoveMember.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.RemoveTeamMemberRequest$inboundSchema,
};

export const tool$authTeamsRemoveMember: ToolDefinition<typeof args> = {
  name: "auth-teams-remove-member",
  description: `Remove a team member`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await authTeamsRemoveMember(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
